<template>
  <div class="test-content">
    <ul>
      <MultipleLi v-for="(pep,index) in arr" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></MultipleLi>
    </ul>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import MultipleLi from '../components/MultipleLi';
  import axios from 'axios';
  import qs from 'qs';
  import setWechatTitle from '@/utils/setWechatTitle.js'
  export default {
    props: {
      id: Number
    },
    name: 'Excellent',
    components: {
      'MultipleLi': MultipleLi
    },
    data() {
      return {
        arr: [{
            'num': 1,
            'order': '1/45',
            'title': '我对学习新知识、新技能有强烈的渴求。',
            'show': true
          },
          {
            'num': 2,
            'order': '2/45',
            'title': '我经常总结自己成功和失败的经验，以寻找提高自己能力的途径。',
            'show': false
          },
          {
            'num': 3,
            'order': '3/45',
            'title': '我善于分析自己目前知识和技能结构与任务要求的差距，并快速采取行动来弥补。',
            'show': false
          },
          {
            'num': 4,
            'order': '4/45',
            'title': '我善于用多种途径为自己创造学习机会，不断尝试新的学习方法。',
            'show': false
          },
          {
            'num': 5,
            'order': '5/45',
            'title': '我能够将学习目标与职业规划相结合，并制定相应的学习计划。',
            'show': false
          },
          {
            'num': 6,
            'order': '6/45',
            'title': '我重视并且乐意沟通，愿意与人建立联系；在遇到沟通障碍时，能够用积极心态和不懈的努力对待冲突和矛盾。',
            'show': false
          },
          {
            'num': 7,
            'order': '7/45',
            'title': '我能够不以自我为中心，尝试从对方的角度和立场考虑问题。',
            'show': false
          },
          {
            'num': 8,
            'order': '8/45',
            'title': '我重视信息的分享，善于倾听各方的意见，并及时调整和回应。',
            'show': false
          },
          {
            'num': 9,
            'order': '9/45',
            'title': '我能够有意识的在群体中搭建沟通平台，从而保证沟通顺畅。',
            'show': false
          },
          {
            'num': 10,
            'order': '10/45',
            'title': '我可以感知到自己当前的情绪，正确评价自己当前的情绪状态。',
            'show': false
          },
          {
            'num': 11,
            'order': '11/45',
            'title': '我能够在压力面前保持冷静，控制负面情绪',
            'show': false
          },
          {
            'num': 12,
            'order': '12/45',
            'title': '我能够区分出核心与非核心的目标，善于排除干扰，将大部分精力用在最重要的任务上。',
            'show': false
          },
          {
            'num': 13,
            'order': '13/45',
            'title': '我擅长寻找良好的情绪支点，保持高昂斗志',
            'show': false
          },
          {
            'num': 14,
            'order': '14/45',
            'title': '我能够用良好的言行和形象赢得他人信任和尊重，并懂得欣赏与信任他人',
            'show': false
          },
          {
            'num': 15,
            'order': '15/45',
            'title': '我能够及时了解他人观点，并澄清自己的想法，以便迅速明确问题，开展合作',
            'show': false
          },
          {
            'num': 16,
            'order': '16/45',
            'title': '我看重他人的观点和才能，愿意向别人学习',
            'show': false
          },
          {
            'num': 17,
            'order': '17/45',
            'title': '我能在较短时间里找到自己对于团队的最佳贡献区，调整并承担相应职责',
            'show': false
          },
          {
            'num': 18,
            'order': '18/45',
            'title': '我能够为团队目标的实现尽心尽力，不计较个得失，以作为团队的一员而骄傲',
            'show': false
          },
          {
            'num': 19,
            'order': '19/45',
            'title': '我善于剥离问题的表面，判断问题产生的根源，澄清关键问题。',
            'show': false
          },
          {
            'num': 20,
            'order': '20/45',
            'title': '在问题解决中，我会充分利用团队优势，借助他人的力量帮自己突破个人思维定势。',
            'show': false
          },
          {
            'num': 21,
            'order': '21/45',
            'title': '在问题解决过程中，我善于提出多种方案，并对每一个方案进行评估，寻求最优方案。',
            'show': false
          },
          {
            'num': 22,
            'order': '22/45',
            'title': '在遇到疑难问题时，我能快速做出合适的决定，在解决问题过程中，喜欢有些冒险的行动。',
            'show': false
          },
          {
            'num': 23,
            'order': '23/45',
            'title': '我善于总结经验，在经验总结基础上，提升问题解决能力。',
            'show': false
          },
          {
            'num': 24,
            'order': '24/45',
            'title': '我对于突发事件有一定的应急处理能力。',
            'show': false
          },
          {
            'num': 25,
            'order': '25/45',
            'title': '我对于信息保持开放的心态，密切关注新的动态。',
            'show': false
          },
          {
            'num': 26,
            'order': '26/45',
            'title': '我干预质疑传统和常识，能够提出与众不同的观点、见解和方法。',
            'show': false
          },
          {
            'num': 27,
            'order': '27/45',
            'title': '我敢于承担风险去尝试新方法。',
            'show': false
          },
          {
            'num': 28,
            'order': '28/45',
            'title': '我对潜在的危机比较敏感，通过自身的发展应对未来的挑战。',
            'show': false
          },
          {
            'num': 29,
            'order': '29/45',
            'title': '我对新观点和新方法表示欢迎和赞同。',
            'show': false
          },
          {
            'num': 30,
            'order': '30/45',
            'title': '我对目标能坚持推进，不断朝向目标努力。',
            'show': false
          },
          {
            'num': 31,
            'order': '31/45',
            'title': '我在遇到阻力的时候能够从不同角度做出努力促进实现目标。',
            'show': false
          },
          {
            'num': 32,
            'order': '32/45',
            'title': '我能够分层次采取最佳策略来实现目标，而不是用一种简单方法重复尝试。',
            'show': false
          },
          {
            'num': 33,
            'order': '33/45',
            'title': '我在遇到困难和阻力的时候又较强的抗压能力，能够迅速调整自己的状态。',
            'show': false
          },
          {
            'num': 34,
            'order': '34/45',
            'title': '我能够根据外界提供的信息，结合自己以往的经验与认知，对事物的性质与状态形成清晰的认识。',
            'show': false
          },
          {
            'num': 35,
            'order': '35/45',
            'title': '我能够对事物的是与非、对与错、好与坏、真与假等品质做出恰当的评判和区分。',
            'show': false
          },
          {
            'num': 36,
            'order': '36/45',
            'title': '我擅长对事物经过分析、理解、判断以及综合等逻辑思维过程后，得出结论。',
            'show': false
          },
          {
            'num': 37,
            'order': '37/45',
            'title': '在问题较为模糊的时候，我可以对零散信息进行整合加工，界定问题的关键，选择最合适的方案。',
            'show': false
          },
          {
            'num': 38,
            'order': '38/45',
            'title': '我能够通过网络、报章杂志书籍、会议和人际交流等多种途径，快速获得大量信息。',
            'show': false
          },
          {
            'num': 39,
            'order': '39/45',
            'title': '我能够有意识地做好信息的分类、整理和贮存，以便在必要时可以迅速调用。',
            'show': false
          },
          {
            'num': 40,
            'order': '40/45',
            'title': '我能够从零散的信息中，敏锐地洞察社会、行业以及市场等的新动向、新趋势，并判断分析出潜在的发展机会。',
            'show': false
          },
          {
            'num': 41,
            'order': '41/45',
            'title': '我能够将来源不同的信息整合起来，并看出信息中呈现的新动向和新趋势。',
            'show': false
          },
          {
            'num': 42,
            'order': '42/45',
            'title': '我能够迅速地分析、理解和整合信息，并转化成语言，清晰地表达出来。',
            'show': false
          },
          {
            'num': 43,
            'order': '43/45',
            'title': '我能够综合运用言语、肢体以及书面等多种表达方式，准确传达信息。',
            'show': false
          },
          {
            'num': 44,
            'order': '44/45',
            'title': '我善于利用简洁、精炼，深入浅出的语言，使得对方容易快速理解，且乐于接受。',
            'show': false
          },
          {
            'num': 45,
            'order': '45/45',
            'title': '我能够根据环境场合的差异、沟通对象的职业、性别和个性等不同，随机应变地采取不同的表达方式和策略。',
            'show': false
          },
        ],
        answer:'',
        submitNum:0
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    created(){
      setWechatTitle('生涯驿站-优秀大学生图鉴');
    },
    methods: {
      showMsg(res, cur){
        this.arr.map((item)=>{
          if (item.show) {
            item.show = false;
          }
          if (item.num == (cur + 1)) {
            item.show = true;
            return true;
          } else if ((cur + 1) > 45) {
            console.log("循环结束");
          }
        })
        this.answer += cur + "$" + res;
        if ((cur + 1) <= 45) {
          this.answer += "}";
        } else {
          if(this.submitNum==0){
            this.submitNum =1
            const options = {
                method: 'POST',
                headers: {'content-type': 'application/x-www-form-urlencoded'},
                data: qs.stringify({
                  submitdata: this.answer,
                  openId: this.shengyaUser.openid
                }),
                url: '/cob/saveCosExcellentAnswer.do'
              };
              axios(options)
                .then((response)=>{
                  if(response.data.result.success){
                    let cosAnswer = response.data
                    let shengyaUser = cosAnswer.data.user
                    this.$bus.$emit('play-finish', shengyaUser)
                  }
                })
                .catch((error)=>{
                  console.log(error);
                });
            }
          }
      }
    }
  }
</script>
<style>


</style>
